<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text"> Причины блокировки </span>
        <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false"
          color="var(--app-dark-blue-1)">mdi-information</v-icon>
      </div>
    </div>

    <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
      <v-card min-width="300px" min-height="100px">
        <div class="menu-container">
          <div class="menu-container-title">«Причины блокировки»</div>
          <div class="menu-container-text">
            Предустановленные причины блокировки, у которых можно редактировать
            параметры
          </div>
        </div>
      </v-card>
    </v-menu>

    <div class="container-table-box">
      <v-data-table :headers="tableHeaders" :items="items" :footer-props="{
        itemsPerPageOptions: [10, 25, 50],
        'items-per-page-text': '',
      }" item-key="id" :search="search" :items-per-page="optionTable.itemsPerPage"
        :server-items-length="optionTable.serverItemsLength" @pagination="tableChange" :page="optionTable.page"
        class="elevation-0 rounded-0 container-table">
        <template v-slot:item.actions="{ item }">
          <v-icon @click="openDialog(item)">mdi-pencil-outline</v-icon>
        </template>
        <template v-slot:item.warning="{ item }">
          {{ item.warning.description }}
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.duration.durationUnit }}
        </template>
      </v-data-table>
    </div>

    <v-dialog width="570px" height="auto" persistent v-model="dialog">
      <v-card width="570px" height="auto" class="rounded-0">
        <v-form ref="formSecond">
          <v-card-title class="dialog-title">
            <span class="title">Редактировать причину</span>
            <v-icon @click="closeDialog">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <v-select :items="durations" class="mt-2" outlined item-text="durationUnit" item-value="id"
              v-model="selectedItem.durationId" label="Время блокировки"></v-select>
            <v-select :items="warnings" outlined item-text="description" item-value="id" v-model="selectedItem.warningId"
              label="Вид предупреждения"></v-select>
            <v-text-field outlined v-model="selectedItem.title" label="Текст предупреждения"></v-text-field>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn style="width: 120px !important" @click="saveReason" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  data: () => ({
    showInfo: false,
    x: null,
    y: null,
    search: "",
    dialog: false,
    selectedItem: {},
    items: [],
    warnings: [],
    durations: [],
    tableHeaders: [
      { text: "Навзание", sortable: false, value: "title" },
      { text: "Время блокировки", sortable: false, value: "time" },
      { text: "Вид предупреждения", sortable: false, value: "warning" },
      { text: "", sortable: false, align: "right", value: "actions" },
    ],
    optionTable: {
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: -1,
    },
  }),
  methods: {
    openDialog(item) {
      if (item) {
        this.selectedItem = Object.assign({}, item);
        this.dialog = true;
      } else {
        this.dialog = true;
      }
    },
    closeDialog() {
      this.selectedItem = {};
      this.dialog = false;
    },

    openInfo(e) {
      e.preventDefault();
      this.x = e.clientX + 10;
      this.y = e.clientY + 10;
      this.showInfo = true;
    },
    tableChange(data) {
      this.optionTable.page = data.page;
      this.optionTable.itemsPerPage = data.itemsPerPage;
      this.getItems();
    },
    getItems() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/club/blocking/reason/list",
          {
            optionTable: this.optionTable,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.items = res.data.items;
          this.optionTable = res.data.optionTable;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getWarnings() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV2 + "/club/blocking/warning/list",
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.warnings = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getDurations() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV2 + "/club/blocking/duration/list",
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.durations = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    saveReason() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/club/blocking/reason",
          {
            reasonId: this.selectedItem.id,
            warningId: this.selectedItem.warningId,
            durationId: this.selectedItem.durationId,
            title: this.selectedItem.title,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.selectedItem = {};
          this.dialog = false;
          this.getItems();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
  mounted() { },
  created() {
    this.getItems();
    this.getWarnings();
    this.getDurations();
  },
};
</script>
<style lang="scss" scoped>
.container-table-box {
  height: calc(100vh - 186px) !important;
  overflow: auto;

  .container-table {
    height: calc(100vh - 186px) !important;
    min-height: calc(100vh - 186px) !important;
    max-height: calc(100vh - 186px) !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

.dialog-description-subtitle {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 24px;
}
</style>